import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GraphService } from './graph.service';

@Injectable({
  providedIn: 'root',
})
export class AlmacenService {
  constructor(
    private http: HttpClient,
    private queryGQL: GraphService,
  ) {}

  deleteIngreso(id: String): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation deleteIngreso($id: String!){
        deleteIngreso(id: $id){
          id,
        }
      }`,
      variables: { id },
    });
  }

  getAllMenajeria(): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query{
            getAllMenajeria{
              id,
              nombre,
              modelo,
              marca,
              cantidad,
              factura{
                razonSocial,
                ruc,
                numFactura
              }
            }
          }`,
      variables: {},
    });
  }

  getAllProveedores(): Observable<any> {
    //return this.proveedoresOb.pipe(delay(2000));

    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query{
         getAllProvider{
            id,
            tipoProveedor,
            nombre,

          }
      }`,
      variables: {},
    });
  }

  getIngreso(id: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getIngreso($id:String!){
        getIngreso(id:$id){
            factura{
              razonSocial,
              ruc,
              numFactura
            },
            locacion,
            id,
           detalleInsumos{
            nombreInsumo,
            unidadMedida,
            cantidad,
            costo,
            categoria,

          }
        }
      }`,
      variables: { id },
    });
  }

  getMenajeria(id: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getMenajeria($id:String!){
        getMenajeria(id:$id){
            id,
            nombre,
            marca,
            modelo,
            cantidad,
            factura{
              razonSocial,
              ruc,
              numFactura
            }
        }
      }`,
      variables: { id },
    });
  }

  createIngreso(almacenInsumo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation createIngreso($almacenInsumo: inputAlmacen_Dto!){
        createIngreso(almacenInsumo: $almacenInsumo){
          id,
          factura{
            numFactura,
            ruc,
            razonSocial
          },
          locacion,
          fechaEntrada,
          detalleInsumos{
            id,
            nombreInsumo,
            unidadMedida,
            cantidad,
            costo,
            categoria
          }
        }
      }`,
      variables: { almacenInsumo },
    });
  }

  createMenajeria(menajeria: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation createMenajeria($menajeria: inputMenajeria_Dto!){
        createMenajeria(menajeria: $menajeria){
          id,
          nombre,
          marca,
          modelo,
          cantidad
        }
      }`,
      variables: { menajeria },
    });
  }

  updateIngreso(id: String, almacenInsumo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateIngreso($id:String!, $almacenInsumo: inputAlmacen_Dto!){
        updateIngreso(id:$id, almacenInsumo: $almacenInsumo){
             id,
          factura{
            razonSocial,
            ruc,
            numFactura
          },
          locacion,
          fechaEntrada,
          detalleInsumos{
            id,
            nombreInsumo,
            unidadMedida,
            cantidad,
            costo,
            categoria
          }
        }
      }`,
      variables: { id, almacenInsumo },
    });
  }

  updateFileEquipos(id: String, equipos: any): Observable<any> {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateItineraryEquipos($id:String!, $equipos: [inputEquipoInventario_Dto!]!){
        updateItineraryEquipos(id:$id, equipos: $equipos){
          id
        }
      }`,
      variables: { id, equipos },
    });
  }

  updateMenajeria(id: String, menajeria: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateMenajeria($id:String!, $menajeria: inputMenajeria_Dto!){
        updateMenajeria(id:$id, menajeria: $menajeria){
          nombre,
          marca,
          modelo,
          cantidad
        }
      }`,
      variables: { id, menajeria },
    });
  }

  getAllFileEquipos() {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query{
        getAllFileEquipos{
    			id,
    			 equipos{
            id,
            nombreEquipo,
            marcaEquipo,
            modeloEquipo,
            tallaEquipo,
            valoracionEquipo,
            observacionEquipo,
            cantidad,
            costo,
            categoria
            estado,

          }
          estadoFile,
          dateRange,
          fileName,
          estado,
          fileNumber,
          paxQuantity,
    			createdAt,
          updatedAt,
          itinerarios{
            services{
              id,
              contador,
              serviceId,
              serviceId,
              productId,
              tipoServicio
            }
          }
        }
      }`,
      variables: {},
    });
  }

  getAllAgrupadoItinerario() {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query{
        getAllAgrupadoItinerario{
          id
          itinerarioId
          productId
          agrupadoId
          selected
        }
      }`,
      variables: {},
    });
  }

  queryGetAllFileProductsAventura({
    exclusiveStartKeyId = null,
  }: {
    exclusiveStartKeyId: string | null;
  }): Observable<{
    getAllFileProductsAventura: {
      lastEvaluatedKeyId: string | null;
      productFiles: any[];
    };
  }> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query GetAllFileProductsAventura ($exclusiveStartKeyId: String) {
        getAllFileProductsAventura (exclusiveStartKeyId: $exclusiveStartKeyId) {
          lastEvaluatedKeyId,
          productFiles {
            fileNumber
            numberOrdenSalida
            idOrdenSalida
            categoryAgrupado
            fileId
            cantPax
            productId
            productName
            fechaInicio
            fechaFin
            lstPaX {
              flightIds
              passengerId
              type
              Pax
              estado
              grupo
              acumulado
            }
          }
        }
      }`,
      variables: {
        exclusiveStartKeyId,
      },
    });
  }

  getAllAgrupadoByFileAndProduct(
    itineraryId: String,
    productId: String,
  ): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getAllAgrupadoByFileAndProduct($itineraryId:String!,$productId:String!){
        getAllAgrupadoByFileAndProduct(itineraryId:$itineraryId,productId:$productId){
          id
          productId
          agrupadoId
          selected
          itineraryId
          agrupadoInfo{
            equipoId
            nombreEquipo
            marcaEquipo
            pesoEquipo
            modeloEquipo
            tallaEquipo
            nroPersonasPax
          }
        }
      }`,
      variables: { itineraryId, productId },
    });
  }

  updateAgrupadoItinerario(id: String, item: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateAgrupadoItinerario($id:String!, $item: inputAgrupadoItinerario_Dto!){
        updateAgrupadoItinerario(id:$id, item: $item){
          id
        }
      }`,
      variables: { id, item },
    });
  }

  getAllEquiposByEquipoId(id: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getAllEquiposByEquipoId($id:String!){
        getAllEquiposByEquipoId(id:$id){
          id
          equipoId
          codigo
          valoracionEquipo
          observacionEquipo
        }
      }`,
      variables: { id },
    });
  }

  createEgresoEquipo(egreso: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation createEgresoEquipo($egreso: inputEgresoEquipo_Dto!){
        createEgresoEquipo(egreso: $egreso){
          id,
        }
      }`,
      variables: { egreso },
    });
  }

  getAllEgresoEquiposByFileAndProductIdAndEquipoId(
    fileId: String,
    productId: String,
    equipoId: String,
  ): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getAllEgresoEquiposByFileAndProductIdAndEquipoId($fileId:String!,$productId:String!,$equipoId:String!){
        getAllEgresoEquiposByFileAndProductIdAndEquipoId(fileId:$fileId,productId:$productId,equipoId:$equipoId){
          id
          equipoInventarioId
          fileId
          productId
          equipoId

        }
      }`,
      variables: { fileId, productId, equipoId },
    });
  }

  getAllEgresoEquiposByFileId(fileId: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getAllEgresoEquiposByFileId($fileId:String!){
        getAllEgresoEquiposByFileId(fileId:$fileId){
          id
          equipoInventarioId
          fileId
          productId
          equipoId

        }
      }`,
      variables: { fileId },
    });
  }

  getAllEgresoEquiposByFileAndProductId(
    fileId: String,
    productId: String,
  ): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getAllEgresoEquiposByFileAndProductId($fileId:String!,$productId:String!){
        getAllEgresoEquiposByFileAndProductId(fileId:$fileId,productId:$productId){
          id
          equipoInventarioId
          fileId
          productId
          equipoId

        }
      }`,
      variables: { fileId, productId },
    });
  }

  deleteEgreso(id: String): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation deleteEgreso($id: String!){
        deleteEgreso(id: $id){
          id,
        }
      }`,
      variables: { id },
    });
  }

  createOrdenSalida(ordenSalida: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation createOrdenSalida($ordenSalida: inputOrdenSalida_Dto!){
        createOrdenSalida(ordenSalida: $ordenSalida){
          id,
          ordenSalidaNumber
        }
      }`,
      variables: { ordenSalida },
    });
  }

  deleteOrdenSalida(id: String): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation deleteOrdenSalida($id: String!){
        deleteOrdenSalida(id: $id){
          id,
        }
      }`,
      variables: { id },
    });
  }

  getServicesDataForPdf(fileId: String, productId: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getServicesDataForPdf($fileId:String!,$productId:String!){
        getServicesDataForPdf(fileId:$fileId,productId:$productId){
          id
          productId
          idItinerary
          categoriaServicio
          tipoServicio
          serviceId
          objProvider{
            id
            nombre
          }

        }
      }`,
      variables: { fileId, productId },
    });
  }
}
